import { render, staticRenderFns } from "./WsTag.vue?vue&type=template&id=15840801&scoped=true"
import script from "./WsTag.vue?vue&type=script&lang=js"
export * from "./WsTag.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15840801",
  null
  
)

export default component.exports